
import Vue from 'vue';
import { ObserveVisibility } from 'vue-observe-visibility';
import ItemType from './enums/ItemType';

Vue.directive('observe-visibility', ObserveVisibility);
export default {
  name: 'B2CItemCard',

  data() {
    return {
      ItemType,
      isAddedProduct: false,
      threshold: 0.33,
    };
  },
  props: {
    /**
     * The unique identifier for the item
     */
    id: {
      type: String,
      required: true,
    },
    /**
     * The type of the item (product/treatment)
     * Possible values: 'P', 'T'
     */
    type: {
      type: String,
      required: true,
      validator(value) {
        return Object.values(ItemType).includes(value);
      },
    },
    /**
     * The URL of the item image.
     */
    imageUrl: {
      type: String,
      required: true,
    },
    /**
     * The name of the item (product or treatment), used in the item card title.
     */
    title: {
      type: String,
      required: true,
    },
    /**
     * If product: the brand name of the item; if treatment: the duration of the treatment.
     * Used in the item card subtitle
     */
    subtitle: {
      type: String,
      required: true,
    },

    /**
     * The price of the item (product or treatment)
     * Used in the card description text
     */
    price: {
      type: Number,
      required: true,
    },

    /**
     * Determines whether to display the price on the card
     * Defaults to true
     */
    showPrice: {
      type: Boolean,
      default: true,
    },
    /**
     * The available stock amount for the product
     * Only applicable if the item is a product
     */
    stockAmount: {
      type: Number,
    },
    /**
     * Text for a campaign associated with the item (optional)
     */
    campaignText: {
      type: String,
    },
    /**
     * Value of discount percentage for a campaign associated with the item (optional)
     */
    campaignValue: {
      type: Number,
    },

    border: {
      type: Boolean,
      default: false,
    },
    isAdded: {
      type: Boolean,
      default: false,
    },
    isFavorite: {
      type: Boolean,
      default: false,
    },
    /**
     * If this prop is passed, the 'Add to cart' button will be replaced by a button
     * with the prop's text. Emits button click event to parent which will handle any logic.
     */
    overrideText: {
      type: String,
      default: null,
    },
    /**
     * If this prop is true, then an event is emitted when the card is visible to the user. It's only emitted once,
     * and is being used to log views.
     */
    logViews: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    redirect() {
      this.$emit('clickCard', {
        id: this.id,
        type: this.type,
      });
    },
    logView(isVisible) {
      if (isVisible) {
        this.$emit('logView', { id: this.id, type: this.type }, 1);
      }
    },
    addToCart() {
      if (
        !this.$refs.cardRef.$el.classList.contains('add-hidden') &&
        (this.stockAmount > 0 || this.type == ItemType.T)
      ) {
        if (this.type == ItemType.P) {
          this.isAddedProduct = true;
          setTimeout(() => {
            this.isAddedProduct = false;
          }, 1000);
        }
        this.$emit('clickButton', {
          id: this.id,
          type: this.type,
        });
      }
    },
  },
};
